<h2 mat-dialog-title i18n>Select Customer</h2>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="start stretch">
    <mat-form-field>
      <input
        matInput
        type="text"
        i18n-placeholder
        placeholder="Search for customer"
        [(ngModel)]="search"
        (keyup)="search = $any($event.target)?.value; refreshList()"
      />
      <mat-icon matPrefix>search</mat-icon>
      <button
        mat-button
        *ngIf="search"
        matSuffix
        mat-icon-button
        i18n-aria-label
        aria-label="Clear"
        (click)="search = ''; refreshList()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-list>
      <ng-container *ngFor="let customer of data.customers">
        <mat-list-item
          class="highlightRow"
          [ngClass]="{ 'selected-customer': customer.id === data.selected.id }"
          (click)="selectCustomer(customer)"
        >
          <mat-icon
            matListItemIcon
            svgIcon="home-account"
            [color]="highlightedCustomer === customer ? 'primary' : ''"
          ></mat-icon>

          <span
            matListItemTitle
            (mouseenter)="highlightedCustomer = customer"
            (mouseleave)="highlightedCustomer = null"
          >
            {{ customer.name }}
          </span>
        </mat-list-item>
        <mat-divider></mat-divider>
      </ng-container>
    </mat-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="15px"
>
  <button mat-button [mat-dialog-close]="data.selected" i18n>Close</button>
</mat-dialog-actions>
